import { Box, Divider, Button as ECButton, Spacer } from '@eatclubapp/ec-component-library';
import { useTheme } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { editBookingAction, updateBookingStepAction } from '../../data/actions/bookingAction';
import { bookingPropTypes, bookingSteps } from '../../data/models/Booking';
import { dietaryTagsPropTypes } from '../../data/models/DietaryTag';
import { isEmpty, joinList } from '../../utils/helpers';
import { getLabelForValue } from '../../utils/valueLists';
import { Typography } from '../Typography';
import useStyles from './DietariesSummaryStyles';

const DietariesSummary = ({ booking, updateBookingStep, dietaryTags, editBooking }) => {
  const classes = useStyles();
  const theme = useTheme();

  const dietaryOptions = [
    ...dietaryTags.data.map((dietaryTag) => ({
      label: dietaryTag.dietaryTag,
      value: dietaryTag.id,
    })),
    {
      value: 'other',
      label: 'Other',
    },
  ];

  const dietaries = booking.dietaryRequirements.map((dietaryRequirement, index) => {
    return {
      ...dietaryRequirement,
      id: index,
      name: index === 0 ? booking.firstName : dietaryRequirement?.name,
      dietaries: dietaryRequirement?.dietaries.filter((item) => item !== 'other') ?? [],
    };
  });

  return (
    <Spacer direction='vertical' gap={32}>
      <Spacer direction='vertical'>
        <Typography variant='h3'>Dietaries</Typography>
        <Typography style={{ color: theme.colors.secondaryTextColour }}>
          Please provide all dietaries before the booking date.
        </Typography>
      </Spacer>

      <Spacer gap={24} direction='vertical'>
        {dietaries.map((dietary, index) => (
          <Fragment key={dietary?.id}>
            <Spacer className={classes.guestRow}>
              <Box className={classes.guestName}>{dietary.name ?? `Guest ${index + 1}`}</Box>
              <Spacer direction='vertical' className={classes.guestAllergies} gap={12}>
                {isEmpty(dietary.dietaries) && isEmpty(dietary.dietaryNotes) && <Box>N/A</Box>}
                <Spacer className={classes.allergyPills} gap={12}>
                  {joinList(
                    dietary.dietaries.map((allergy) => getLabelForValue(allergy, dietaryOptions)),
                    ', ',
                    ', ',
                  )}
                </Spacer>
                {!isEmpty(dietary.dietaryNotes) && <Typography>{dietary.dietaryNotes}</Typography>}
              </Spacer>

              <Box style={{ textAlign: 'right' }}>
                <ECButton
                  type='text'
                  style={{
                    button: { fontSize: '14px' },
                    buttonHover: { textDecoration: 'underline' },
                  }}
                  onClick={() => {
                    // TODO go to exact guest
                    editBooking();
                    updateBookingStep(bookingSteps.details, dietary?.id);
                  }}
                >
                  Edit
                </ECButton>
              </Box>
            </Spacer>

            {/* Show dividers except on the last one */}
            {index < dietaries.length - 1 && <Divider color={theme.colors.dividerColor} />}
          </Fragment>
        ))}
      </Spacer>
    </Spacer>
  );
};

DietariesSummary.defaultProps = {};

DietariesSummary.propTypes = {
  booking: bookingPropTypes.isRequired,
  updateBookingStep: PropTypes.func.isRequired,
  editBooking: PropTypes.func.isRequired,
  dietaryTags: dietaryTagsPropTypes.isRequired,
};

const mapStateToProps = (state) => ({
  booking: state.booking,
  dietaryTags: state.dietaryTags,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateBookingStep: updateBookingStepAction,
      editBooking: editBookingAction,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(DietariesSummary);
